import { dateLocaleMap } from 'config/localization/languages'
import { formatDuration } from 'date-fns'
import { Language } from 'vvs-uikit'

/**
 * Format VVSBoost pool timestamp
 * @param timestamp duration in minutes
 * @returns Formatted duration
 */
const formatTimestampDuration = (timestamp: number, lang: Language): string => {
  let value = timestamp

  const units = {
    years: 30 * 24 * 60 * 60 * 12,
    months: 30 * 24 * 60 * 60,
    days: 24 * 60 * 60,
    hours: 60 * 60,
    minutes: 60,
    seconds: 1,
  }

  const result = []
  let isUseRoughEstimation = false

  Object.keys(units).forEach((key) => {
    const p = Math.floor(value / units[key])
    value %= units[key]

    if (p >= 1) {
      result.push(isUseRoughEstimation ? '' : formatDuration({ [key]: p }, { locale: dateLocaleMap[lang.locale] }))

      if (key === Object.keys(units)[0]) {
        isUseRoughEstimation = true
      }
    }
  })

  return result.join(' ')
}

export default formatTimestampDuration
